import { RoleGate } from "@/components/layout/RoleGate";
import { useAuthStore } from "@/store/authStore";
import { usePermissions } from "@/hooks/usePermissions";
import { Role } from "@/lib/constants/roles";

/**
 * Aligns SPA routing with backend `CredentialsCompanyAdminOrGroupPermission`:
 * break-glass org roles or `services.view` on merged permission groups from GET /auth/me/.
 * Server remains authoritative; this avoids mounting the lazy credentials bundle for unauthorized users.
 * A refused address is said in place, as `AdminGuard` does, not bounced to the dashboard unexplained.
 */
export function CredentialsRouteGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user } = useAuthStore();
  const { can } = usePermissions();

  const allowed =
    user?.role === Role.PLATFORM_ADMIN ||
    user?.role === Role.PLATFORM_MANAGER ||
    user?.role === Role.DISTRIBUTOR_ADMIN ||
    user?.role === Role.MSP_ADMIN ||
    user?.role === Role.COMPANY_OWNER ||
    user?.role === Role.COMPANY_ADMIN ||
    can("services", "view");

  if (!allowed) {
    return (
      <RoleGate
        title="Credentials"
        requirement="administrators and members whose group grants it"
      />
    );
  }

  return <>{children}</>;
}
